import React from "react";
import { connect } from "react-redux";
import TabInstructions from "components/request/TabInstructions";
import instructions from "dictionaries/TabInstructions";

const RenewalBubble = ({ request }) => {
  if (!request) return null;

  return <TabInstructions messages={instructions.renewalSite} />;
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(RenewalBubble);
